import { render } from "./LearningSessions.vue?vue&type=template&id=563f98e7"
import script from "./LearningSessions.vue?vue&type=script&lang=js"
export * from "./LearningSessions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__